import type { Recent } from "app/custom-hooks/useRecentsHook";
import { DEFAULT_KEYWORDS } from "app/pages/activation/components/HomeSearch/config";
import {
    createRecentKeywordItem,
    generateKeywordResponse,
} from "app/pages/activation/components/HomeSearch/helpers";
import { createDefaultKeywordsItem } from "app/pages/activation/components/HomeSearch/helpers/createDefaultKeywordsItem";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";

type GetKeywordsItemsSchema = {
    query: string;
    recentKeywords: Recent[];
    onClick?: OnSearchItemClick;
};

export const getKeywordsItems = async ({ query, recentKeywords, onClick }: GetKeywordsItemsSchema) => {
    const hasQuery = !!query?.length;
    const hasRecent = !!recentKeywords.length;

    if (hasQuery) {
        return await generateKeywordResponse(query, onClick);
    }

    if (hasRecent) {
        return recentKeywords.map((recent) => createRecentKeywordItem(recent, onClick));
    }

    return DEFAULT_KEYWORDS.map((keyword) => createDefaultKeywordsItem(keyword, onClick));
};
